(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bcs-auction-currency-estimates"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var lastKey = '';
  function selectedCurrency() {
    var nodes = document.querySelectorAll('.bacurr-choiceDesign .ba-chosen');
    for (var i = 0; i < nodes.length; i++) {
      var code = nodes[i].textContent.trim().toUpperCase();
      if (/^[A-Z]{3}$/.test(code)) return code;
    }
    return '';
  }
  function locale() {
    var s = window.Shopify || {};
    return (s.locale || document.documentElement.lang || 'en') + (s.country && !(s.locale || '').includes('-') ? '-' + s.country : '');
  }
  function text(panel, key, currency) {
    return (panel.dataset[key] || '').split('__CURRENCY__').join(currency);
  }
  function amountFromText(value) {
    if (!value || !/\d/.test(value)) return null;
    var group = ',', decimal = '.';
    try {
      new Intl.NumberFormat(locale()).formatToParts(12345.6).forEach(function (part) {
        if (part.type === 'group') group = part.value;
        if (part.type === 'decimal') decimal = part.value;
      });
    } catch (e) {}
    var cleaned = value.split(group).join('').split(decimal).join('.').replace(/[^0-9.\-]/g, '');
    if (!/^-?\d+(\.\d+)?$/.test(cleaned)) return null;
    var result = Number(cleaned);
    return Number.isFinite(result) && result >= 0 ? result : null;
  }
  function status(panel, source, key) {
    var stateKey = source + ':' + key;
    if (panel.dataset.fxKey !== stateKey) {
      panel.querySelector('.bcs-auction-fx__values').replaceChildren();
      panel.querySelector('.bcs-auction-fx__title').textContent = text(panel, 'baseTitle', source);
      panel.querySelector('.bcs-auction-fx__note').textContent = text(panel, key, source);
      panel.dataset.fxKey = stateKey;
    }
    panel.hidden = false;
    lastKey = '';
  }
  function update() {
    if (document.hidden) return;
    var panel = document.querySelector('[data-bcs-auction-fx]');
    if (!panel) return;
    var base = panel.dataset.baseCurrency;
    var source = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || base;
    var target = selectedCurrency() || source;
    if (source !== base) { panel.hidden = true; lastKey = ''; return; }
    if (target === source) return status(panel, source, 'baseNote');
    var nova = window.baCurr;
    var widget = Array.from(document.querySelectorAll('#codeBlock-auction-widget')).find(function (node) { return node.getClientRects().length > 0; });
    if (!widget) return status(panel, source, 'waitingNote');
    if (!nova || !nova.Currency || typeof nova.Currency.convert !== 'function') return status(panel, source, 'unavailableNote');
    var rates = nova.Currency.rates || {};
    if (!(Number(rates[source]) > 0) || !(Number(rates[target]) > 0)) return status(panel, source, 'unavailableNote');
    var rows = [];
    widget.querySelectorAll('.auction-details-list-item').forEach(function (row) {
      var spans = Array.from(row.children).filter(function (child) { return child.tagName === 'SPAN'; });
      if (spans.length !== 2 || row.querySelector('#codeBlock-no-of-bids')) return;
      var value = amountFromText(spans[1].textContent);
      var label = spans[0].textContent.trim();
      if (value !== null && label) rows.push({ label: label, amount: value });
    });
    if (!rows.length) return status(panel, source, 'waitingNote');
    var input = widget.querySelector('#codeBlock-auction-input-element');
    if (input && /^\d+(\.\d+)?$/.test(input.value)) rows.push({ label: text(panel, 'enteredBid', source), amount: Number(input.value) });
    var converted;
    try {
      var formatter = new Intl.NumberFormat(locale(), { style: 'currency', currency: target, currencyDisplay: 'code' });
      converted = rows.map(function (row) {
        var value = nova.Currency.convert(row.amount, source, target);
        if (!Number.isFinite(value) || value < 0) throw new Error('Unavailable exchange rate');
        return { label: row.label, amount: formatter.format(value) };
      });
    } catch (e) { return status(panel, source, 'unavailableNote'); }
    var key = JSON.stringify([source, target, converted]);
    if (key === lastKey && panel.dataset.fxKey === key) { panel.hidden = false; return; }
    var list = panel.querySelector('.bcs-auction-fx__values');
    var fragment = document.createDocumentFragment();
    converted.forEach(function (row) {
      var entry = document.createElement('div');
      var label = document.createElement('dt');
      var value = document.createElement('dd');
      label.textContent = row.label;
      value.textContent = row.amount;
      entry.appendChild(label);
      entry.appendChild(value);
      fragment.appendChild(entry);
    });
    list.replaceChildren(fragment);
    panel.querySelector('.bcs-auction-fx__title').textContent = text(panel, 'targetTitle', target);
    panel.querySelector('.bcs-auction-fx__note').textContent = text(panel, 'convertedNote', source);
    panel.dataset.fxKey = key;
    panel.hidden = false;
    lastKey = key;
  }
  document.addEventListener('input', function (event) {
    if (event.target && event.target.id === 'codeBlock-auction-input-element') update();
  });
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
  window.setInterval(update, 1000);
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bcs-product-description"] && !Shopify.designMode) return;
  try {
    (function () {
  function removeEmptyCaptions() {
    document.querySelectorAll('.bcs-product-description .wp-caption').forEach(function (caption) {
      var hasText = caption.textContent.replace(/\u00a0/g, ' ').trim().length > 0;
      var hasMedia = caption.querySelector('img, picture, video, audio, iframe, svg, canvas, object, embed, input, button');
      if (!hasText && !hasMedia) caption.hidden = true;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeEmptyCaptions, { once: true });
  } else {
    removeEmptyCaptions();
  }
  document.addEventListener('shopify:section:load', removeEmptyCaptions);
})();
  } catch(e) { console.error(e); }
})();

})();
